import React from "react";
import ConditionEditor from "./ConditionEditor";

/**
 * Edits a switch's cases: [{ label, condition }]. Records take the FIRST matching case; anything
 * unmatched falls to the implicit "Otherwise" lane. Each case's label names its lane in the canvas.
 */
const CasesEditor = ({ value, onChange, fields }) => {
  const cases = Array.isArray(value) ? value : [];
  const setCase = (idx, patch) => onChange(cases.map((c, i) => (i === idx ? { ...c, ...patch } : c)));
  const addCase = () => onChange([...cases, { label: `Case ${cases.length + 1}`, condition: { join: "all", rules: [] } }]);
  const removeCase = idx => onChange(cases.filter((_, i) => i !== idx));

  return (
    <div className="ag-cases">
      {cases.map((c, idx) => (
        <div className="ag-case" key={idx}>
          <div className="ag-case__head">
            <span className="ag-case__num">{idx + 1}</span>
            <input className="ag-input ag-case__label" value={c.label || ""} placeholder="Lane name (e.g. VPs)"
              onChange={e => setCase(idx, { label: e.target.value })} />
            <button type="button" className="ag-cond__del material-icons-outlined" title="Remove case"
              onClick={() => removeCase(idx)}>close</button>
          </div>
          <ConditionEditor value={c.condition} fields={fields} onChange={cond => setCase(idx, { condition: cond })} />
        </div>
      ))}
      <button type="button" className="ag-cond__add" onClick={addCase}>+ Add case</button>
      <div className="ag-case__else">Anything that matches no case goes to the <b>Otherwise</b> lane.</div>
    </div>
  );
};

export default CasesEditor;
